import apiSlice from "./apiSlice";

const manpowerDashboardSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllManpowerPlanActual: builder.query({
      query: (req) => ({
        url: `manpower/kpi/manpower`,
        params: req,
      }),
    }),
    getManpowerShortfallByCategory: builder.mutation({
      query: ({ projectId, categoryList }) => ({
        url: `manpower/kpi/manpower/shortfall-by-category`,
        method: "POST",
        params: { projectId },
        body: categoryList,
      }),
    }),
    getManpowerHistogram: builder.mutation({
      query: ({ body, params }) => ({
        url: `manpower/kpi/manpower/histogram`,
        method: "POST",
        body,
        params,
      }),
    }),
    getUpcomingRequirement: builder.query({
      query: (req) => ({
        url: `manpower/kpi/manpower/upcoming-requirement`,
        params: req,
      }),
    }),
    getProductivity: builder.mutation({
      query: ({ projectId, year, body }) => ({
        url: `manpower/kpi/manpower/productivity`,
        method: "POST",
        params: { projectId, year },
        body,
      }),
    }),
  }),
});

export const {
  useGetAllManpowerPlanActualQuery,
  useGetManpowerShortfallByCategoryMutation,
  useGetManpowerHistogramMutation,
  useGetUpcomingRequirementQuery,
  useGetProductivityMutation,
} = manpowerDashboardSlice;

export default manpowerDashboardSlice;
